export const formatOutgoingDoctorInfo = (
  doctorName: string,
  specialization: string,
) => [doctorName, specialization].join('\n');

export const parseOutgoingDoctorInfo = (surnameDoctor: string) => {
  const [namePart, specializationPart] = surnameDoctor.split('\n');

  return {
    doctorName: (namePart ?? '').trim() || null,
    doctorSpecialization: (specializationPart ?? '').trim() || null,
  };
};
